export class AssistantAppearanceComponent {
    readonly activeFlex = 'active-flex';
    readonly interfaceActive = 'safety-functionality__unified-interface-tab--active';
    private appearanceTabs: HTMLElement[] ;
    private tabContentItems: HTMLElement[];

    constructor(
        private container: HTMLElement
    ) {
        this.appearanceTabs = Array.prototype.slice.call(this.container.querySelectorAll('[data-interface-tab]'));
        this.tabContentItems = Array.prototype.slice.call(this.container.querySelectorAll('[data-tab-content]'));
    }
    public initialize(): void {
        this.appearanceTabs.forEach((tab, index) => {
            tab.addEventListener('click', (e) => {
                this.appearanceTabs.forEach((interfaceTab) => {
                    interfaceTab.classList.remove(this.interfaceActive);
                });
                this.appearanceTabs[index].classList.add(this.interfaceActive);
                this.tabContentItems.forEach((tabContentItem) => {
                    tabContentItem.classList.remove(this.activeFlex);
                });
                this.tabContentItems[index].classList.add(this.activeFlex);
            });
        });
    }
}
